import { z } from "zod";
import { localizedTextInputSchema, localizedTextSchema } from "@shared/locale/localized-text";
import { CHART_TYPES } from "@shared/enums";
import { paginationQuerySchema } from "@shared/schemas/common";

export const specialtySchema = z.object({
  id: z.uuid(),
  clinicId: z.uuid(),
  code: z.string(),
  name: localizedTextSchema,
  chartType: z.enum(CHART_TYPES),
  isActive: z.boolean(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});
export type Specialty = z.infer<typeof specialtySchema>;

export const specialtySummarySchema = specialtySchema.pick({
  id: true,
  code: true,
  name: true,
  chartType: true,
});
export type SpecialtySummary = z.infer<typeof specialtySummarySchema>;

export const listSpecialtiesQuerySchema = paginationQuerySchema.extend({
  isActive: z.stringbool().optional(),
});
export type ListSpecialtiesQuery = z.infer<typeof listSpecialtiesQuerySchema>;

export const updateSpecialtySchema = z.object({
  name: localizedTextInputSchema(1, 80),
});
export type UpdateSpecialtyInput = z.infer<typeof updateSpecialtySchema>;
